import React, { useState } from "react";
import { VerificationForm } from "../../../../widgets/VerificationForm";
import Unsuccess from "../../../../shared/assets/icons/unsuccess.svg";
import { useAppSelector } from "../../../../shared/store";
import { SIGNATURES } from "../../../../shared/consts";

export const UnsuccessVerificationForm = () => {
  const offerData = useAppSelector((state) => state.payment.offer);

  const description = (
    <div>
      <p>
        Мы не нашли ваш платеж! Загрузите чек в формате pdf в форме ниже для
        верификации.
      </p>
      <p
        style={{
          fontWeight: 700,
        }}
      >
        Если вы отправили не ту сумму, пожалуйста, обратитесь в тех. поддержку.
      </p>
    </div>
  );
  const title = "Неуспешная оплата";

  return (
    <>
      {offerData && (
        <VerificationForm
          cardNumber={true}
          icon={Unsuccess}
          title={title}
          description={description}
          orderNum={offerData ? String(offerData.humanId) : null}
          textBtn="Отправить чек"
          isSumFieldVisible={false}
          attachFile={true}
          offerData={offerData}
          inputSetting={{
            accept: offerData.canUploadVerificationImages
              ? "application/pdf, image/png, image/jpeg, image/jpg"
              : "application/pdf",
            signatures: offerData.canUploadVerificationImages
              ? [...SIGNATURES.pdf, ...SIGNATURES.jpg, ...SIGNATURES.png]
              : SIGNATURES.pdf,
            fileInputPlaceholder: offerData.canUploadVerificationImages
              ? "Выберите файл"
              : "Выберите pdf файл",
            warn: offerData.canUploadVerificationImages
              ? "Необходимо загрузить корректный файл"
              : "Необходимо загрузить pdf файл",
          }}
        />
      )}
    </>
  );
};
